module.exports = __webpack_public_path__ + "4900fd4191d77909a9c558837e53c42e.png";